import React from 'react';
import { Link } from 'react-router-dom';
import './SentInstructions.css';

const SentInstructions = ({ resetEmail }) => {
  return (
    <div className="sentInstructionsPanel">
      <div className="sentInstructionsPanelWrapper">
        <div className="secondaryText" data-dd-privacy="mask">
          We've sent an email with instructions to <b>{resetEmail}</b>. If you don't see the email in your inbox within
          15 minutes, check your spam or junk folder.
          <br />
          <br />
          We're here to help you, please visit our{' '}
          <a
            key="helpLink"
            href="https://help.fox.com/fox/s/topic/0TO1H000000HHQUWA4/fox-nation"
            className="blueLink"
            target="_blank"
          >
            <span className="secondaryText helpCenterLink">Help Center</span>
          </a>{' '}
          if you need additional help.
        </div>
        <a href="https://nation.foxnews.com/" className="pillButton">
          Back to Fox Nation
        </a>
      </div>
    </div>
  );
};

export default SentInstructions;
